import LeagueSeasonDivisionIndex from './LeagueSeasonDivisionIndex';
import LeagueSeasonDivisionCreate from './LeagueSeasonDivisionCreate';
import LeagueSeasonDivisionSettings from './LeagueSeasonDivisionSettings';
import LeagueSeasonDivisionSingle from './LeagueSeasonDivisionSingle';

export default function (app) {

    const settings = LeagueSeasonDivisionSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueSeasonDivisionIndex(app, settings);

    LeagueSeasonDivisionCreate(app, settings);

    LeagueSeasonDivisionSingle(app, settings);

}